import { transformApplicantToApi, transformMerchantId } from '@applyonline/shared'
import { Prequalification } from '../types/Schemas/PrequalificationSchema'


export function transformPrequalToApi(prequal: Prequalification): Prequalification {
  return {
    ...prequal,
    merchantId: transformMerchantId(prequal.merchantId, 'alis'),
    applicant: transformApplicantToApi(prequal.applicant),
  } as Prequalification
}
